import React from "react";
import * as S from "./CabDriverDetails.styles";

interface ICabDriverDetails {
  margin: string;
  t: string;
  details: Array<string>;
  st: string;
  icon: string;
  msg: string;
}

const CabDriverDetailsUI: React.FC<ICabDriverDetails> = ({
  margin = '',
  t = '',
  details = [],
  st = '',
  icon = '',
  msg = ''
}) => {
  return (
    <S.CabDetailsContainer margin={margin}>
      <h4 className="font22 textDark fontMedium rubik">{t}</h4>
      <div className="makeFlex hrtlCenter">
        <div className="appendRight28 noShrink">
          {!!icon && <img src={icon} alt="details" />}
        </div>
        {!!st && <div className="makeFlex column">
          <div className="font14 textDark" dangerouslySetInnerHTML={{ __html: st }}/>
          {!!msg && <div className="font16 textDark fontMedium appendTop5" dangerouslySetInnerHTML={{ __html: msg }}/>}
        </div>}
      </div>
    </S.CabDetailsContainer>
  );
};

export default CabDriverDetailsUI;
